export enum MandateNotificationTypeEnum {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
  BOTH = 'BOTH'
}

